var DialogLinkModule = /** @class */ (function () {
    function DialogLinkModule() {
    }
    return DialogLinkModule;
}());
export { DialogLinkModule };
